import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { SnapList, SnapItem, useDragToScroll } from 'react-snaplist-carousel';
import { EventCard } from '../event-card';
import { useCarouselPadding } from '../../../shared/hooks/use-carousel-padding';
import { CARD_GAP } from '../../constants';
import { EventData, EventTranslation } from '../../types';

interface EventsHorizontalCarouselProps {
  eventsData: EventData[];
  eventsTranslations: Record<string, EventTranslation>;
}

const EventsHorizontalCarousel: React.FC<EventsHorizontalCarouselProps> = ({
  eventsData,
  eventsTranslations,
}) => {
  const { t } = useTranslation();
  const snapListRef = useRef<HTMLDivElement>(null);

  useDragToScroll({ ref: snapListRef });

  const paddingHorizontal = useCarouselPadding();

  if (eventsData.length === 0) {
    return (
      <div className="mb-7 mt-10 flex items-center justify-center">
        <div className="text-center">
          <p className="text-sm text-text-secondary">
            {t('js.features.marketplace.home.community_events.no_events')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <SnapList ref={snapListRef as any} direction="horizontal" className="my-8">
      {eventsData.map((event, idx) => {
        const translation = eventsTranslations[event.id] || { title: '' };

        return (
          <SnapItem
            key={event.id}
            margin={{
              left: idx === 0 ? `${paddingHorizontal}px` : `${CARD_GAP}px`,
              right: idx === eventsData.length - 1 ? `${paddingHorizontal}px` : `${CARD_GAP}px`,
            }}
            snapAlign="center"
          >
            <EventCard
              eventId={event.id}
              imageUrl={event.imageUrl}
              title={translation.title}
            />
          </SnapItem>
        );
      })}
    </SnapList>
  );
};

export { EventsHorizontalCarousel };
